const currentUser = (state = {}, action) => {
  switch (action.type) {
    default: return state;
  }
};

export default currentUser;
